<template>
  <v-main>
    <v-row dense>
      <v-col cols="12">
        <v-text-field
          label="Titre du cv"
          v-model="formFields.cvTitle"
          placeholder="Ex: Graphic Designer & Web Developer"
          prepend-inner-icon="mdi-cellphone-sound"
          light
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="formFields.cv"
          truncate-length="30"
          placeholder="Ajouter un CV"
          prepend-icon="mdi-upload-outline"
          show-size
          accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*"
        >
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>
      </v-col>
      <v-col cols="12">
        <v-btn
          elevation="24"
          large
          rounded
          color="primary"
          style="width: 100%"
          v-on:click="submitCv"
        >
          <v-icon left> mdi-content-save-check</v-icon>
          Uploader
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbarFailed"
      rounded="pill"
      elevation="24"
      color="red darken-3"
    >
      <span class="text-subtitle-1">
        {{ snackbarFailedMessage }}
      </span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="snackbarFailed = false"
        >
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarSucceed"
      rounded="pill"
      elevation="24"
      color="green darken-3"
    >
      <span class="text-subtitle-1">
        {{ snackbarSucceedMessage }}
      </span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="snackbarSucceed = false"
        >
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "UploadCvInCvteque",
  components: {},
  data: () => ({
    snackbarFailed: false,
    snackbarSucceed: false,
    snackbarFailedMessage: "",
    snackbarSucceedMessage: "",
    seeker: null,
    formFields: {
      cv: null,
      cvTitle: "",
    },
    e6: 1,
  }),

  created() {
    this.fetchCurrentSeeker();
  },

  methods: {
    fetchCurrentSeeker() {
      const httpClient = new HttpClient();
      httpClient
        .getCurrentSeeker(localStorage.getItem("jwt-token"))
        .then((res) => {
          this.seeker = res.data;
        });
    },
    submitCv() {
      if (this.formFields.cvTitle.length > 0 && this.formFields.cv !== null) {
        const httpClient = new HttpClient();
        const formData = new FormData();
        formData.append("cvFile", this.formFields.cv);
        httpClient
          .uploadSeekerCvFile(formData, localStorage.getItem("jwt-token"))
          .then(async (value) => {
            let tmpSeeker = {
              id: this.seeker.id,
              cvTitle: this.formFields.cvTitle,
            };

            await httpClient
              .updateSeekerInformations(
                tmpSeeker,
                localStorage.getItem("jwt-token")
              )
              .then((res) => {
                this.seeker = res.data;
                this.snackbarSucceed = true;
                this.snackbarSucceedMessage =
                  "Le cv a bien été publié dans la cvtèque";
              })
              .catch((reason) => {
                if (reason.response.status === 401) {
                  this.$router.push("/logout");
                }

                alert("Le fichier est trop volumineux");
                alert("Une erreur s'est produite : " + reason);
              });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push("/logout");
            } else {
              this.snackbarFailedMessage =
                "Une erreur s'est produite avec le CV : " + error;
              this.snackbarFailed = true;
            }
          });
      } else {
        this.snackbarFailedMessage = "Veuillez completer le formulaire";
        this.snackbarFailed = true;
      }
    },
  },
});
</script>

<style scoped></style>
